import { Component, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { StockStoreService } from "@services/stockStore.service";
import { BarcodeFormat } from "@zxing/library";
import { ZXingScannerComponent } from "@zxing/ngx-scanner";
import { ToastService } from "angular-toastify";
import { Guid } from "guid-typescript";

@Component({
	encapsulation: ViewEncapsulation.None,
	moduleId: module.id,
	selector: "stockControl",
	styleUrls: ["stockControl.css"],
	templateUrl: "stockControl.html"
})
export class StockControlComponent {
	allowedFormats = BarcodeFormat.QR_CODE;
	availableDevices: MediaDeviceInfo[] = [];
	dateTime = new Date;
	hasCameras = false;
	hasPermission = false;
	readonly maxPinLength = 8;
	readonly minPinLength = 4;
	mode = 0;
	modeText = "";
	pinError = "";
	pinInput = "";
	pinSlots = Array(8).fill(0);
	result = "";
	scanner: ZXingScannerComponent = new ZXingScannerComponent();
	scannerEnabled = true;
	private scanningIntervalId: any;

	scanningLineTop = 0;
	selectedDevice: any;
	showPinModal = true;
	userCode = 0;

	constructor(private stockStoreService: StockStoreService, private toastService: ToastService, private router: Router, private route: ActivatedRoute) {
		this.getCameras();
		this.route.params
			.subscribe(async (params) => {
				this.mode = Number.parseInt(params.id);
				if (Number.parseInt(params.id) == 2) { this.modeText = "Relocate"; } else {
					if (Number.parseInt(params.id) == 0) {
						this.modeText = "Check In";
					} else {
						this.modeText = "Check Out";
					}
				}
			});

		// Get Supervisor Code
		// const code = window.prompt("Please enter your user code to continue", "");
		// if (code == null) {
		// 	window.history.back();
		// }
		// this.userCode = Number.parseInt(code!);
	}

	cameraFound(e: any) {
		// Log to see if the camera was found
		console.log(e);
		this.availableDevices = e;
		this.selectedDevice = e[0];
		this.hasCameras = true;
		this.hasPermission = true;
		console.log("Devices: ", this.availableDevices);

		// selects the devices's back camera by default'
		for (const device of e) {
			if (/back|rear|environment/gi.test(device.label)) {
				new this.scanner.deviceChange(true);
				this.selectedDevice = device;
				break;
			} else if (e.length == 1) {
				new this.scanner.deviceChange(true);
				this.selectedDevice = device;
				break;
			}
		}
	}

	camerasNotFound() {
		// Display an alert modal here
	}

	canSubmit(): boolean {
		return this.pinInput.length >= this.minPinLength;
	}

	clearPin(): void {
		this.pinInput = "";
		this.pinError = "";
	}

	getCameras() {
		console.log("Hit!");
	}

	goBack() {
		window.history.back();
	}

	ngOnInit(): void {
		// this.updateClock();
		// this.clockIntervalId = setInterval(() => this.updateClock(), 1000);
		this.startScanningLineAnimation();
	}

	onBackspace(): void {
		if (this.pinInput.length === 0) {
			return;
		}
		this.pinInput = this.pinInput.slice(0, -1);
		this.pinError = "";
	}

	onDeviceSelectChange() {
		console.log("Selection changed: ", this.selectedDevice.label);
		// this.selectedDevice = this.scanner.device!;
	}

	onDigitPress(digit: string): void {
		if (this.pinInput.length >= this.maxPinLength) {
			return;
		}
		this.pinInput += digit;
		this.pinError = "";
	}

	onOkPress(): void {
		if (this.canSubmit()) {
			this.submitPin();
		}
	}


	onPinCancel(): void {
		// Up to you – this could just clear, or navigate away.
		this.pinInput = "";
		this.pinError = "";
		this.goBack(); // or remove this line if you don't want Cancel to leave
	}

	onPinLogin(): void {
		if (this.canSubmit()) {
			this.submitPin();
		}
	}

	onScanSuccess(result: string) {
		if (this.mode !== 2) {
			const input = window.prompt("Enter Quantity to " + this.modeText, "");
			if (input == null) {
				return;
			}
			console.log("Result: ", result);
			if (this.mode == 0) {
				this.stockStoreService.app_CheckIn(Guid.parse(result), parseFloat(input!), this.userCode)
					.subscribe(
						() => {
							this.toastService.success(this.modeText + " Successful!");
						},
						(err) => {
							console.log(err);
							this.toastService.error("Something Went Wrong!");
						}
					);
			} else {
				this.stockStoreService.app_CheckOut(Guid.parse(result), parseFloat(input!), this.userCode)
					.subscribe(
						() => {
							this.toastService.success(this.modeText + " Successful!");
						},
						(err) => {
							console.log(err);
							this.toastService.error("Something Went Wrong!");
						}
					);
			}
		} else {
			const input = window.prompt("Enter New Location", "");
			this.stockStoreService.app_PlacedItem(Guid.parse(result), input!)
				.subscribe(
					() => {
						this.toastService.success("Stock Relocated!");
					},
					(err) => {
						console.log(err);
						this.toastService.error("Something Went Wrong!");
					}
				);
		}
	}

	onSwitchCamera() {
		console.log("Switch camera");
	}

	onToggleFlash() {
		console.log("Toggle flash");
	}

	private startScanningLineAnimation(): void {
		const maxPosition = 280;
		this.scanningLineTop = 0;

		this.scanningIntervalId = setInterval(() => {
			this.scanningLineTop += 2;
			if (this.scanningLineTop > maxPosition) {
				this.scanningLineTop = 0;
			}
		}, 50);
	}

	submitPin(): void {
		// basic check – plug in your own auth here if needed
		this.showPinModal = false;
		this.userCode = Number.parseInt(this.pinInput);
		this.pinError = "";
		this.pinInput = "";

	}


}